import { DeviceResponseReportWrapper } from "src/repositories/api/dto/DeviceResponseReportWrapper";
import { physicalDeviceTimeWindowGroupsApi } from "src/repositories/api/physical-device/time-window-group/PhysicalDeviceTimeWindowGroup.api";
import { GeneralApiResponse } from "src/repositories/api/Utils/ResponseUtility";
import { reduxStore } from "src/services/redux/ReduxStore";
import timeWindowGroupListSlice from "src/services/redux/slices/TimeWindowGroupSlice";
import {
  handleGeneralErrorPostAction,
  handleGeneralErrorResponse,
  methodWrapper,
} from "src/services/utils/Utils.service";

async function upload(
  deviceSn: string
): Promise<
  GeneralApiResponse<DeviceResponseReportWrapper<TimeWindowGroup[] | undefined>>
> {
  const result = await physicalDeviceTimeWindowGroupsApi.upload(deviceSn);
  if (!result.success) {
    handleGeneralErrorResponse(result);
    return result;
  }

  if (result.value.value != undefined) {
    reduxStore.dispatch(
      timeWindowGroupListSlice.actions.addEditItems(result.value.value)
    );
  }
  return result;
}

export const physicalDeviceTimeWindowGroupsService = {
  get: methodWrapper(
    physicalDeviceTimeWindowGroupsApi.get,
    handleGeneralErrorPostAction
  ),
  download: methodWrapper(
    physicalDeviceTimeWindowGroupsApi.download,
    handleGeneralErrorPostAction
  ),
  upload,
};
